module.exports = __webpack_public_path__ + "static/media/ergoapp3.811d8a72.png";